@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/mixins/typography" as t;

.switcher {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
  background: v.$palette-white;
  box-shadow: v.$shadow-2;
  min-width: 0;
}

.option {
  @include t.text(13px, 18px, 500);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 32px;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  flex: 1 1 auto;
  background: transparent;
  color: v.$palette-gray-900;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  svg {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }

  &.active {
    background: v.$palette-blue-light-5;
    color: v.$palette-blue;
  }

  &:focus-visible {
    outline: 2px solid v.$palette-blue;
    outline-offset: 2px;
  }

  @include c.containerMedia(v.$js-defined-mobile-breakpoint) {
    min-height: 36px;
    min-width: 36px;
    padding: 8px;
  }
}

.divider {
  width: 1px;
  height: 16px;
  background: v.$palette-gray-300;
  flex-shrink: 0;
}
